import { ShareOrderStatus, ShareOrderType } from './shareTradeShare';

export enum UpdatedShareOrderStatus {
  Unspecified = 'UPDATED_STATUS_UNSPECIFIED',
  Amended = 'UPDATED_STATUS_AMENDED',
  Cancelled = 'UPDATED_STATUS_CANCELLED',
}

export enum ShareTradeLabel {
  UNSPECIFIED = 'LABEL_UNSPECIFIED',
  DAY_TRADE = 'LABEL_DAY_TRADE',
  SPLIT_ORDER = 'LABEL_SPLIT_ORDER',
}

export interface ShareTradeInfo {
  text: string;
  symbol: string;
  order_type: ShareOrderType;
  order_time: string;
  status: ShareOrderStatus;
  updated_status: UpdatedShareOrderStatus;
  price: string;
  updated_price: string;
  parent_order_id: string;
  label: ShareTradeLabel;
  total_investment: string;
}
